import { api } from '@/api';
import { type BookingDTO } from '@/types/dto/agent';

export const fetchInitiateRefund = async (
  bookingId: BookingDTO['id'],
  fulfillmentIds: Array<string>
) => {
  if (!bookingId) {
    return null;
  }

  const response = await api.agentApi.RefundOffers_InitiateRefund(
    { bookingId },
    { fulfillmentIds }
  );

  return response.data;
};
